import { httpClient } from '../http/httpClient'

export interface MaritalStatus {
  label: string
  value: string
}

export async function getMaritalStatus() {
  const { data } = await httpClient.get<MaritalStatus[]>('/pan/matrial-status')
  return data
}
